import { FileResponse } from 'types/Request';
import * as types from './types';

const initialState = {
  birthday: {
    day: '',
    month: '',
    year: ''
  },
  address: '',
  addressLine2: '',
  zipCode: '',
  city: '',
  country: '',
  birthPlace: {
    address: '',
    city: '',
    zipCode: '',
    country: '',
  },
  gender: '',
  firstname: '',
  lastname: '',
  phone: '',
  files: {
    idCardRecto: {
      status: 'IDLE',
      type: 'id_card_recto',
      file: null,
      error: null
    },
    idCardVerso: {
      status: 'IDLE',
      type: 'id_card_verso',
      file: null,
      error: null,
    },
    passport: {
      status: 'IDLE',
      type: 'passport',
      file: null,
      error: null,
    },
    homeCertificate: {
      status: 'IDLE',
      type: 'home_certificate',
      file: null,
      error: null,
    }
  },
  isUploading: false,
  success: false,
  fetch: {
    status: 'IDLE',
    error: null,
  }
};

interface DynamicPayload {
  name: string;
  value: string;
}

type InvestorAction = {
  type: typeof types[keyof typeof types];
  payload?: Partial<types.InvestorState> | string | FileResponse | DynamicPayload;
};

export default function investorReducer(state = initialState, action: InvestorAction) {
  const { type, payload } = action;
  switch (type) {
    case 'RESET_INVESTOR_FETCH':
      return {
        ...state,
        fetch: {
          ...state.fetch,
          status: 'IDLE'
        }
      }
    case 'FETCH_INVESTOR_REQUEST':
      return {
        ...state,
        fetch: {
          ...state.fetch,
          status: 'LOADING',
        },
      };
    case 'FETCH_INVESTOR_SUCCESS':
      return {
        ...state,
        ...payload as types.InvestorState,
        fetch: {
          ...state.fetch,
          status: 'SUCCESS'
        },
      }
    case 'FETCH_INVESTOR_FAIL':
      return {
        ...state,
        fetch: {
          ...state.fetch,
          status: 'FAIL',
          error: payload,
        }
      }
    case 'UPLOAD_INVESTOR_FILE_REQUEST':
      if (payload !== 'idCardRecto' && payload !== 'idCardVerso') return;
      return {
        ...state,
        files: {
          ...state.files,
          [payload]: {
            ...state.files[payload],
            status: 'LOADING'
          }
        }
      };
    case 'UPLOAD_INVESTOR_FILE_SUCCEEDED':
      let fileNameSucceed = (payload as FileResponse)?.type;
      if (fileNameSucceed !== 'idCardRecto' && fileNameSucceed !== 'idCardVerso') return;
      return {
        ...state,
        files: {
          ...state.files,
          [fileNameSucceed]: {
            ...state.files[fileNameSucceed],
            status: 'SUCCESS',
            file: (payload as FileResponse).url
          }
        }
      };
    case 'UPLOAD_INVESTOR_FILE_FAILED':
      let fileNameFailed = (payload as FileResponse)?.type;
      if (fileNameFailed !== 'idCardRecto' && fileNameFailed !== 'idCardVerso') return;
      return {
        ...state,
        files: {
          ...state.files,
          [fileNameFailed]: {
            ...state.files[fileNameFailed],
            status: 'ERROR',
            error: (payload as FileResponse)?.error,
          }
        }
      };
    case 'RESET_INVESTOR_FILE':
      if (payload !== 'idCardRecto' && payload !== 'idCardVerso') return;
      return {
        ...state,
        files: {
          ...state.files,
          [payload]: {
            ...state.files[payload],
            status: 'IDLE',
            file: null,
          }
        }
      };
    case 'SEND_INVESTOR_DATA':
      return { ...state, isUploading: true };
    case 'RECEIVE_INVESTOR_SUCCESS':
      return { ...state, isUploading: false, success: true };
    case 'RECEIVE_INVESTOR_FAIL':
      return { ...state, isUploading: false, success: false }
    case 'UPDATE_BIRTHDAY':
      return { ...state, birthday: payload };
    case 'UPDATE_BIRTHPLACE':
      return {
        ...state,
        birthPlace: {
          ...state.birthPlace,
          [(payload as DynamicPayload).name]: (payload as DynamicPayload).value,
        },
      };
    case 'UPDATE_ADDRESS':
      return { ...state, address: payload };
    case 'UPDATE_ADDRESS_LINE_2':
      return { ...state, addressLine2: payload };
    case 'UPDATE_ZIP_CODE':
      return { ...state, zipCode: payload };
    case 'UPDATE_CITY':
      return { ...state, city: payload };
    case 'UPDATE_COUNTRY':
      return { ...state, country: payload };
    case 'UPDATE_INVESTOR_INFO':
      return { ...state, ...payload as types.InvestorState };
    case 'UPDATE_FIRSTNAME':
      return { ...state, firstname: payload };
    case 'UPDATE_LASTNAME':
      return { ...state, lastname: payload };
    case 'UPDATE_GENDER':
      return { ...state, gender: action.payload }
    case 'UPDATE_PHONE':
      return { ...state, phone: payload };
    default:
      return state;
  }
}
